import { mode } from '@chakra-ui/theme-tools';
const getSolidStyles = (props) => {
    const { colorScheme } = props;
    const colorSchemes = {
        gray: {
            bg: mode('gray.600', 'gray.100')(props),
            color: mode('white', 'gray.600')(props),
        },
        default: {
            bg: mode(`${colorScheme}.500`, `${colorScheme}.400`)(props),
            color: mode('white', 'gray.600')(props),
        },
    };
    return colorSchemes[colorScheme] || colorSchemes.default;
};
export default {
    baseStyle: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        px: '3',
        py: '2',
        fontSize: 'md',
        lineHeight: '1.25rem',
    },
    variants: {
        solid: getSolidStyles,
    },
    defaultProps: {
        colorScheme: 'blue',
        variant: 'solid',
    },
};
//# sourceMappingURL=banner.js.map